let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8Ned5")).then(() => parcelRequire('lm1k2'));